<template>
    <v-card outlined class="pa-2">
        <v-row class="align-center" :class="`${arabic ? 'arFont' : 'enFont'}`">
            <v-col cols="12" class="py-0">
                <v-row class="align-center">
                    <v-col cols="6" md="3">
                        <div :class="`${arabic ? 'arFont' : 'enFont'}`" style="font-size:11px;font-weight:bold;">
                            {{ i18n["call_center_fees"] }}
                        </div>
                        <div :class="`${arabic ? 'arFont' : 'enFont'}`" style="font-size:9px;">
                            {{ formatCurrency(item.subvendor_call_fees) }}
                        </div>
                    </v-col>
                    <v-col cols="6" md="3">
                        <div :class="`${arabic ? 'arFont' : 'enFont'}`" style="font-size:11px;font-weight:bold;">
                            {{ i18n["shipping_fees_vendor"] }}
                        </div>
                        <div :class="`${arabic ? 'arFont' : 'enFont'}`" style="font-size:9px;">
                            {{ formatCurrency(item.subvendor_shipping_fees) }}
                        </div>
                    </v-col>
                    <v-col cols="6" md="3">
                        <div :class="`${arabic ? 'arFont' : 'enFont'}`" style="font-size:11px;font-weight:bold;">
                            {{ i18n['cod_fees'] }}
                        </div>
                        <div :class="`${arabic ? 'arFont' : 'enFont'}`" style="font-size:9px;">
                            {{ formatCurrency(item.subvendor_cod_fees) }}
                        </div>
                    </v-col>
                    <v-col cols="6" md="3">
                        <div :class="`${arabic ? 'arFont' : 'enFont'}`" style="font-size:11px;font-weight:bold;">
                            {{ i18n["sales_tax_vendor"] }}
                        </div>
                        <div :class="`${arabic ? 'arFont' : 'enFont'}`" style="font-size:9px;">
                            {{ formatCurrency(item.subvendor_tax_fees) }}
                        </div>
                    </v-col>
                    <v-col cols="6" md="3" class="green--text">
                        <div :class="`${arabic ? 'arFont' : 'enFont'}`" style="font-size:11px;font-weight:bold;">
                            {{ i18n['final_invoice_total'] }}
                        </div>
                        <div :class="`${arabic ? 'arFont' : 'enFont'}`" style="font-size:9px;">
                            {{ formatCurrency(item.subvendor_total_fees) }}
                        </div>
                    </v-col>
                </v-row>
                <v-divider></v-divider>
            </v-col>
        </v-row>
    </v-card>

</template>

<script>

export default {
  props: ['item'],
  data() {
    return { dialog: true };
  },
  methods: {
    formatCurrency(amount) {
      const formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
      return formatter.format(amount);
    },
  },
  computed: {
    arabic() {
      return this.$store.state.language === 'ar';
    },
    language() {
        return this.$store.state.language
    },
    globalLoading() {
        return this.$store.state.globalLoading
    },
    user() {
        return this.$store.state.user
    },
    i18n() {
        return this.$store.state.i18n[this.$store.state.language]
    },
  },
};
</script>

<style>

</style>
